module.exports = __webpack_public_path__ + "static/WEDDING E&M-196-8b89def00ae92d5f872230c87f5c005a.jpg";